import React from 'react'
import { config, start } from 'wbap-core-commit'
import myConfig from './config'

// 基础共用模块
import wbap_admin_root from './wbap-mian-apps/wbap-admin-root'
import wbap_admin_login from './wbap-mian-apps/wbap-admin-login'
import wbap_admin_main from './wbap-mian-apps/wbap-admin-main'

// 业务单元模块
import wbap_dashboard_dailyPrice from './wbap-unit-app/wbap-dashboard-dailyPrice'

/**
 * 手动引用基础框架包含的页面
 * 登录,注册,业务主体骨架
 */
const apps = {
  [wbap_admin_root.name]: wbap_admin_root,
  [wbap_admin_login.name]: wbap_admin_login,
  [wbap_admin_main.name]: wbap_admin_main,
  [wbap_dashboard_dailyPrice.name]: wbap_dashboard_dailyPrice
}

// 初始化项目配置信息
config.init(myConfig({apps}))

// 启动项目
start()


// WEBPACK FOOTER //
// ./src/index.js